export default "__VITE_ASSET__EMZXjL9C__"